
import { Component, OnInit } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { FooterComponent } from 'src/app/layouts/full/footer/footer.component';
import { AppTopstripComponent } from 'src/app/layouts/full/top-strip/topstrip.component';
import { ThemeService } from 'src/app/services/theme/theme.service';

@Component({
  selector: 'app-home-layout',
  imports: [AppTopstripComponent, FooterComponent, RouterModule, RouterOutlet],
  templateUrl: './home-layout.component.html',
})
export class HomeLayoutComponent implements OnInit {
  constructor(private themeService: ThemeService) {}

  ngOnInit(): void {
    this.themeService.setGlobalThemeEnabled(false);
  }
}
